function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.24199 7.70609H6.57069V8.78827H2.24199V7.70609ZM2.24199 5.54174H6.57069V6.62392H2.24199V5.54174ZM5.48852 0.130859H1.15981C0.564616 0.130859 0.0776367 0.617839 0.0776367 1.21304V9.87044C0.0776367 10.4656 0.559205 10.9526 1.1544 10.9526H7.65287C8.24806 10.9526 8.73504 10.4656 8.73504 9.87044V3.37739L5.48852 0.130859ZM7.65287 9.87044H1.15981V1.21304H4.94743V3.91848H7.65287V9.87044Z",
  fill: "#3456FF"
});

function SvgIconDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/icon-documents.5bb7f9b5.svg";
export { ForwardRef as ReactComponent };